import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useOperatorsCacheUpdater } from "../../useFetchOperators";

export const useUpdateOperatorSectionTags = () => {
  const { updateActiveOperator } = useOperatorsCacheUpdater();

  return useBoronMutation(
    async ({
      sectionId,
      operatorId,
      tagIds,
    }: {
      sectionId: string;
      operatorId: string;
      tagIds: string[];
    }) => {
      return await boronClient.PATCH(
        "/api/v1/sections/{section_id}/operators/{operator_hashid}/tags",
        {
          params: {
            path: {
              section_id: sectionId,
              operator_hashid: operatorId,
            },
          },
          body: {
            tag_ids: tagIds,
          },
        },
      );
    },
    {
      onSuccess: ({ activeOperator }, { sectionId }) => {
        updateActiveOperator(sectionId, activeOperator);
      },
    },
  );
};
